// components
import { StyledFooterContainer, StyledFooterRow } from './Footer.style';
import { Button } from '@interstate/components/Button';

//props
import type { FooterProps } from '../../types/Footer';

export const Footer = ({ onOpenDeal, isValidDeal }: FooterProps) => {
    return (
        <StyledFooterContainer>
            <StyledFooterRow>
                <Button data-testid="footer-open-deal-button" disabled={!isValidDeal} onClick={onOpenDeal}>
                    Open
                </Button>
            </StyledFooterRow>
        </StyledFooterContainer>
    );
};
